import { ReactElement } from 'react';
import { Table, TableProps } from '@ohpen/enso-ui';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TradingAddressesCRProps = { tableProps: TableProps<any> };

export const TradingAddressesCR = ({ tableProps }: TradingAddressesCRProps): ReactElement => {
  return <Table {...tableProps} />;
};
